import React from 'react';
import { useTranslation } from 'react-i18next';
import { MAP_RATING_COLORS } from '../../../constants/colors';
import './TopRatedInstitutions.css';

interface Institution {
  id: string;
  name: string;
  shortName: string;
  province: string;
  score: number;
  rating: string;
}

interface TopRatedInstitutionsProps {
  institutions: Institution[];
  onInstitutionClick: (inst: { id: string; name: string }) => void;
}

const TopRatedInstitutions: React.FC<TopRatedInstitutionsProps> = ({
  institutions,
  onInstitutionClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="top-rated-section">
      <h3 className="section-title">{t('map.topRatedInstitutions')}</h3>
      <ul className="top-rated-list">
        {institutions.map((inst, index) => (
          <li
            key={inst.id}
            className="top-rated-item"
            onClick={() => onInstitutionClick({ id: inst.id, name: inst.name })}
          >
            <span className="top-rated-rank">{index + 1}</span>
            <div className="top-rated-info">
              <span className="top-rated-name">{inst.shortName}</span>
              <span className="top-rated-province">{inst.province}</span>
            </div>
            <span
              className="top-rated-badge"
              style={{ backgroundColor: MAP_RATING_COLORS[inst.rating] || MAP_RATING_COLORS['N/A'] }}
            >
              {inst.rating}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TopRatedInstitutions;
